<template>
  <div class="errorDiv" v-if="error">
    <van-icon name="clear" size="70" color="red"/>
    <div style="margin-top:40px;">
      <span style="color: rgb(64, 158, 255)">{{ message }}</span>
    </div>
  </div>
</template>
<script>
import {Icon} from 'vant';
import {client} from "@/libraries/http";
import useAuthnStore from "@/store/authn";

export default {
  name: "LoginLoading",
  components: {
    'van-icon': Icon
  },
  created() {
    this.leoLogin();
  },
  data() {
    return {
      error: false,
      message: "TP端参数异常，请联系管理员",
    }
  },
  methods: {
    leoLogin() {
      const params = {
        phoneNumber: this.$route.query.phoneNumber,
        username: this.$route.query.username,
        projectId: this.$route.query.projectId,
        tenantCode: this.$route.query.tenantCode,
        tenantName: this.$route.query.tenantName,
        brand: this.$route.query.brand, // 品牌
        building_name: this.$route.query.building_name,
        company_code: this.$route.query.company_code,
        company_name: this.$route.query.company_name,
        appKey: this.$route.query.appKey,
        invalidTime: this.$route.query.invalidTime,
        sign: this.$route.query.sign
      }
      client.get('/api/public/tp/user/login', {
        headers: {
          'Disable-Toast': 'Disable'
        },
        params: params
      })
          .then(res => {
            const authn = useAuthnStore();
            authn.token({
              token: res.data.token,
              user: {
                loginType: res.data.loginType,
                userName: res.data.userName,
                userPhone: res.data.userPhone
              },
              leoParams: params
            });
            this.$router.push({path: '/myElectronicPass'});
          })
          .catch((e) => {
            // this.$toast.fail({
            //   message: e.response.data?.message || '',
            //   duration: 30 * 1000
            // })
            this.message = e.response.data?.message || 'TP端参数异常，请联系管理员';
            this.error = true;
          });
    }
  }
}
</script>

<style scoped>
.errorDiv {
  width: 200px;
  height: 120px;
  position: absolute;
  top: 40%;
  left: 50%;
  margin: -60px 0 0 -100px;
  text-align: center;
}
</style>

